import { Routes, Route } from 'react-router-dom';

import TransitionComponent from '../components/Transition';

import Home from '../pages/Home';
import ComingSoon from '../pages/ComingSoon';
import Web from '../pages/Web';
import Error from '../pages/Error';

const Router = ({ appLoaded, loadingOn, pageCurrent, setPageCurrent, pageChangeOn, setPageChangeOn, pageOn, setPageOn, setCursorOn }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <TransitionComponent appLoaded={appLoaded} loadingOn={loadingOn} pageCurrent={pageCurrent} setPageCurrent={setPageCurrent} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} errorObj={null}>
            <Home appLoaded={appLoaded} loadingOn={loadingOn} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} setCursorOn={setCursorOn}/>
          </TransitionComponent>
        }
      />
      <Route
        path="/web"
        element={
          <TransitionComponent appLoaded={appLoaded} loadingOn={loadingOn} pageCurrent={pageCurrent} setPageCurrent={setPageCurrent} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} errorObj={null} >
            <Web appLoaded={appLoaded} loadingOn={loadingOn} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} setCursorOn={setCursorOn}/>
          </TransitionComponent>
        }
      />
      <Route
        path="/coming"
        element={
          <TransitionComponent appLoaded={appLoaded} loadingOn={loadingOn} pageCurrent={pageCurrent} setPageCurrent={setPageCurrent} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} errorObj={null} >
            <ComingSoon appLoaded={appLoaded} loadingOn={loadingOn} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} setCursorOn={setCursorOn}/>
          </TransitionComponent>
        }
      />
      <Route path="*" element={
          <TransitionComponent appLoaded={appLoaded} loadingOn={loadingOn} pageCurrent={pageCurrent} setPageCurrent={setPageCurrent} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} errorObj={{status: 404}} >
            <Error appLoaded={appLoaded} loadingOn={loadingOn} pageChangeOn={pageChangeOn} setPageChangeOn={setPageChangeOn} pageOn={pageOn} setPageOn={setPageOn} setCursorOn={setCursorOn} errorObj={{status: 404}}/>
          </TransitionComponent>
        }
      />
    </Routes>
  );
};

export default Router;
